import { createIcon } from '@chakra-ui/react';

export const EmptyDisplayConfigurationIllustration = createIcon({
  displayName: 'EmptyDisplayIllustration',
  viewBox: '0 0 120 149',
  defaultProps: {
    fill: '#F1F8FE',
    width: '120px',
    height: '149px',
  },
  path: (
    <>
      <circle cx="60" cy="60.7754" r="60" fill="#F1F8FE" />
      <path
        d="M48.2223 87.7754H71.7779M60.0001 75.9976V87.7754M36.4446 34.7754H83.5557C86.808 34.7754 89.4446 37.4119 89.4446 40.6643V70.1087C89.4446 73.3611 86.808 75.9976 83.5557 75.9976H36.4446C33.1922 75.9976 30.5557 73.3611 30.5557 70.1087V40.6643C30.5557 37.4119 33.1922 34.7754 36.4446 34.7754Z"
        stroke="#627D98"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});
